/* STEP 3 combined · B3 (owner card 27-Oct-2026 10:19) — EN + AR. Loaded from lib/i18n/ by the generated index (STEP 2 · B2).
   Opening balances: with more than one retained earnings account (FS head 2106) the user picks the account that carries the
   prior-year profit close; until then the close row reads "Account not chosen". */
export const I18N_S3C_RE_PICK = {
  en: {
    s3cRePick: {
      notChosen: "Account not chosen",
      label: "Retained earnings account for the prior-year profit:",
      plClosedNotChosen: "Prior-year profit {amount} ({n} P&L accounts) is carried to retained earnings - more than one retained earnings account exists: choose the account below.",
      pickedBy: "Picked by {name} on {date}",
      saveFailed: "The account could not be saved",
    },
    ob: {
      reasons: {
        re_close_account_not_chosen: "Choose the retained earnings account for the prior-year profit.",
      },
    },
  },
  ar: {
    s3cRePick: {
      notChosen: "لم يُختر الحساب",
      label: "حساب الأرباح المبقاة لربح السنة السابقة:",
      plClosedNotChosen: "يُرحَّل ربح السنة السابقة {amount} ({n} حسابًا من قائمة الدخل) إلى الأرباح المبقاة - يوجد أكثر من حساب للأرباح المبقاة: اختر الحساب أدناه.",
      pickedBy: "اختاره {name} في {date}",
      saveFailed: "تعذّر حفظ الحساب",
    },
    ob: {
      reasons: {
        re_close_account_not_chosen: "اختر حساب الأرباح المبقاة لربح السنة السابقة.",
      },
    },
  },
};

export default I18N_S3C_RE_PICK;
